import {TIER_BLOCK_MESSAGE} from "../actions/const";

const initialState = {
    resetState: false,
    showModal: false,
    isLoadingAction: false,
    
    selectedData: null,
    formType: "",
    formId: "",
    formTitle: "",

    title: "",
    browser: null,
    url: "",
    content: "",

    browserOptions: [
        {
            label: "INTERNAL",
            value: "INTERNAL"
        },
        {
            label: "EXTERNAL",
            value: "EXTERNAL"
        }
    ],

    showModalConfig: false,
    isSavingConfig: false,
    isLoadingConfig: false,
    isActive: false,
    customBlockMessageConfig: null
};

function reducer (state = initialState, action) {
    let { type, payload } = action;

    switch (type) {
        case TIER_BLOCK_MESSAGE:
            if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
                action.payload = {...initialState};
            }
            return Object.assign({}, state, action.payload);
            break;

        default:
            {
                return state;
            }
    }
}

module.exports = reducer;
  


// WEBPACK FOOTER //
// ./reducers/TierBlockMessage.js